export const px2Rem = (px) => `${px / 8}rem`;

export const size2Font = (size) => {
  switch (size) {
    case "small":
      return 22;
    case "large":
      return 26;
    default:
      return 24;
  }
};

export const formatDateTime = (dateTime) => {
  const [yyyy, mm, dd] = dateTime.split("T")[0].split("-");
  return `${dd}/${mm}/${yyyy}`;
};

export const capitalize = (str) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(" ");
};

export const notNull = (value, text = "N/A") => {
  return value || text;
};

export const getValueFromPath = (obj, path) => {
  const keys = path.split(".");

  keys.slice(0, -1).reduce((acc, key) => {
    if (!acc[key]) acc[key] = isNaN(keys[key + 1]) ? {} : [];
    return acc[key];
  }, obj);

  return keys.reduce((acc, key) => {
    if (acc && acc.hasOwnProperty(key)) {
      return acc[key];
    } else {
      return undefined;
    }
  }, obj);
};

export const setValueFromPath = (object, path, value) => {
  const keys = path.split(".");

  keys.slice(0, -1).reduce((acc, key) => {
    if (!acc[key]) acc[key] = isNaN(keys[key + 1]) ? {} : [];
    return acc[key];
  }, object);

  const lastKey = keys.pop();
  const lastObj = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, object);

  lastObj[lastKey] = value;

  return object;
};
